var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntegrations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 16V4H8V16H20ZM20 18H5C4.44772 18 4 18.4477 4 19C4 19.5523 4.44772 20 5 20H20V18ZM22 20C22 21.1046 21.1046 22 20 22H5C3.34315 22 2 20.6569 2 19V4C2 2.89543 2.89543 2 4 2H20C21.1046 2 22 2.89543 22 4V20ZM4 16.1707C4.31278 16.0602 4.64936 16 5 16H6V4H4V16.1707ZM11.4874 10.5123C10.9351 10.5123 10.4874 10.0646 10.4874 9.51227C10.4874 8.95998 10.9351 8.51227 11.4874 8.51227H14.4874C15.0397 8.51227 15.4874 8.95998 15.4874 9.51227C15.4874 10.0646 15.0397 10.5123 14.4874 10.5123H11.4874ZM11.4874 13.5123C10.9351 13.5123 10.4874 13.0646 10.4874 12.5123C10.4874 11.96 10.9351 11.5123 11.4874 11.5123H16.4874C17.0397 11.5123 17.4874 11.96 17.4874 12.5123C17.4874 13.0646 17.0397 13.5123 16.4874 13.5123H11.4874Z",
    fill: "#92929D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrations);
export default __webpack_public_path__ + "static/media/Integrations.536dd5f416c7b41bd944a77db572bd39.svg";
export { ForwardRef as ReactComponent };